import React, {useState} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { RoleCard } from "../components/RoleCard";

const roleData = [
  { title: "Applicant/Contractor", imgSrc: "Contractor.jpg" },
  { title: "Village Officials", imgSrc: "Government.jpg" }
];

function MainContent() {
  const [selectedRole, setSelectedRole] = useState("");

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
    localStorage.setItem("selectedRole", role);
  };
  return (
    <section>
      <Container fluid className="text-center py-5 stream-line">
        <Row>
          <Col>
            <div className="heading large-font fw-bold">
              Village of Pingree Grove
            </div>
            <div className="sub-heading regular-font">
              Please contact <a href="mailto:info@simplepermit.io">info@simplepermit.io</a> or 331-274-9630 for software support or customer service.{" "}
            </div>
          </Col>
        </Row>
        <div>
          <h2 className="selectUser">Select Your Role</h2>
          <div className="d-flex justify-content-center">
            <div className="d-flex justify-content-between align-items-center flex-wrap card-wrapper">
              {roleData.map((card, index) => (
                <RoleCard
                  key={index}
                  imageUrl={card.imgSrc}
                  title={card.title}
                  onRoleSelect={handleRoleSelection}
                ></RoleCard>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default MainContent;
